import { useField } from './useField';

export const useError = <T>() => {
  const error = useField<string | undefined>('');

  const setTimeoutError = (errorMessage: string | undefined, duration?: number | undefined) => {
    error.setValue(errorMessage);
    error.schedule(() => error.setValue(''), duration || 6000);
  };

  return { error, setTimeoutError };
};
